import { gql, apiInstance } from "@/services/httpAdapter";

export async function getSalesPerformancesByCommissionCycle(locationId, id) {
	const query = gql`
		query getSalesPerformancesByCommissionCycle($id: String!, $locationId: String!) {
			getSalesPerformancesByCommissionCycle(id: $id, locationId: $locationId) {
				_id
				salesPerformance {
					_id
					sales {
						_id
						dealNumber
						funded
						customerNumber
						customerName
						dealType
						description
						financeEmployeeId
						financeEmployeeName
						financeEmployeeLocationId
						saleDate
						saleType
						salesEmployeeId
						salesEmployeeName
						salesEmployeeLocationId
						stockNumber
						frontGrossProfit
						backGrossProfit
						units
						frontProducts {
							product
							value
						}
						backProducts {
							product
							value
						}
						external
						sourceLocationId
						identifiers {
							_id
							name
							locationId
							dealerCodeFS
						}
						origin {
							icon
							tooltip
						}
						dealerCodeFS
					}
					identifiers {
						_id
						name
						locationId
						dealerCodeFS
					}
				}
				carryOverFundingProgress {
					_id
					sales {
						_id
						dealNumber
						funded
						customerNumber
						customerName
						dealType
						description
						financeEmployeeId
						financeEmployeeName
						financeEmployeeLocationId
						saleDate
						saleType
						salesEmployeeId
						salesEmployeeName
						salesEmployeeLocationId
						stockNumber
						frontGrossProfit
						backGrossProfit
						units
						frontProducts {
							product
							value
						}
						backProducts {
							product
							value
						}
						external
						sourceLocationId
						identifiers {
							_id
							name
							locationId
							dealerCodeFS
						}
						origin {
							icon
							tooltip
						}
						dealerCodeFS
					}
					identifiers {
						_id
						name
						locationId
						dealerCodeFS
					}
				}
			}
		}
	`;

	const variables = {
		id,
		locationId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getSalesPerformancesByCommissionCycle;
	} catch (err) {
		console.error(err);
		return null;
	}
}

export async function getSalesPerformanceReportVersions(locationId) {
	const query = gql`
		query getSalesPerformanceReportVersions($locationId: String!) {
			getSalesPerformanceReportVersions(locationId: $locationId) {
				_id
				title
				locked
			}
		}
	`;

	const variables = {
		locationId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getSalesPerformanceReportVersions || [];
	} catch (err) {
		console.error(err);
		return [];
	}
}

export async function getSalesPerformanceReportVersion(locationId, id, hasDatePeriods = false) {
	const query = gql`
		query getSalesPerformanceReportVersion($locationId: String!, $id: String!, $filter: SalesPerformanceFilterInput) {
			getSalesPerformanceReportVersion(locationId: $locationId, id: $id, filter: $filter) {
				_id
				locationId
				title
				effectiveDateTime
				saleDate
				saleAmount
				dealNumber
				customerName
				customerNumber
				stockNumber
				description
				saleType
				dealType
				units
				salesEmployeeId
				financeEmployeeId
				salesManagerId
				frontProducts {
					_id
					label
					reportField
					contractUnits
				}
				backProducts {
					_id
					label
					reportField
					contractUnits
				}
				createdOn
				createdBy
				lastModifiedOn
				lastModifiedBy
				locked
				datePeriods {
					startDate
				}
			}
		}
	`;

	const variables = {
		locationId,
		id,
		filter: {
			datePeriods: hasDatePeriods,
		},
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getSalesPerformanceReportVersion;
	} catch (err) {
		console.error(err);
		return null;
	}
}

export async function getCurrentSalesPerformanceFormatVersion(locationId) {
	const query = gql`
		query getCurrentSalesPerformanceReportVersion($locationId: String!) {
			getCurrentSalesPerformanceReportVersion(locationId: $locationId) {
				_id
				locationId
				effectiveDateTime
				frontProducts {
					_id
					label
					reportField
					contractUnits
				}
				backProducts {
					_id
					label
					reportField
					contractUnits
				}
			}
		}
	`;

	const variables = {
		locationId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getCurrentSalesPerformanceReportVersion;
	} catch (err) {
		console.error(err);
		return null;
	}
}

export async function getSalesPerformanceFormatVersionProducts(locationId, id) {
	const query = gql`
		query getSalesPerformanceReportVersion($locationId: String!, $id: String!) {
			getSalesPerformanceReportVersion(locationId: $locationId, id: $id) {
				_id
				locationId
				title
				effectiveDateTime
				frontProducts {
					_id
					label
					reportField
					contractUnits
				}
				backProducts {
					_id
					label
					reportField
					contractUnits
				}
				createdOn
				createdBy
				lastModifiedOn
				lastModifiedBy
			}
		}
	`;

	const variables = {
		locationId,
		id,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getSalesPerformanceReportVersion;
	} catch (err) {
		console.error(err);
		return null;
	}
}
